import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useUserItemUpdate = (id: string) => {
  return useMutation({
    mutationFn: (data) => api.keycloak.updateUserItem(id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить данные пользователя',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Пользователь успешно обновлен',
        type: 'success',
      })
    }
  })
}
